// extracted by mini-css-extract-plugin
module.exports = {"title":"CounterpartyDetailSection_title_38hpa","hint":"CounterpartyDetailSection_hint_3F4IW","item":"CounterpartyDetailSection_item_2Jxey"};